module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point03_02_winter-df1fa4b4766e870c9ce1fb4e3b811a09.jpg";